import { Box, Paper, withStyles, Grid } from "@material-ui/core";
import React from "react";
import _Footer from "./_Footer";
import _Header from "./_Header";
import axios from "../_helpers/interceptor";
import config from "../_config/config";
import getCookie, { setCookie } from "../_helpers/cookies";

const styles = theme => ({
  root: {
    // height: 'calc(100vh - 56px)'
    height: 'calc(100vh - 98px)',
    // backgroundColor: '#F4F4F4',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 162px)',
    },
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 100px)',
    }
  },
  paper: {
    // display: "flex",
    borderRadius: '20px',
    // width: "55vw",
    // width: 1200,
    // height: "60vh",
    width: "470px",
    height: 600,
    // minHeight: "500px",
    // minWidth: "300px",
    paddingBottom: 32,
    backgroundColor: "#FFFFFFCC",
    zIndex: 1,
    [theme.breakpoints.down('lg')]: {
      width: 370,
      height: 472,
      paddingBottom: 20
    },
    [theme.breakpoints.down('md')]: {
      width: 275,
      height: 351,
    },
    [theme.breakpoints.down('sm')]: {
      height: "60vh",
      width: 500,
      paddingBottom: 24
    },
    [theme.breakpoints.down('xs')]: {
      width: "80vw",
      height: "55vh",
      paddingBottom: 20,
      minHeight: 450
    },
  },
  boxstyle: {
    flex: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // paddingLeft: "10%",
    // paddingRight: "10%",
    // width: "50%",
  },
  formCenterContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingLeft: "140px",
    [theme.breakpoints.down('lg')]: {
      paddingLeft: "65px",
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: "70px",
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: "0px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }
  },
  formBoxStyle: {
    paddingLeft: "44px",
    paddingRight: "44px",
    height: "calc(100% - 120px)",
    [theme.breakpoints.down('lg')]: {
      height: "calc(100% - 80px)",
      paddingLeft: "36px",
      paddingRight: "36px",
    },
    [theme.breakpoints.down('md')]: {
      height: "calc(100% - 56px)",
      paddingLeft: "26px",
      paddingRight: "26px",
    },
    [theme.breakpoints.down('sm')]: {
      height: "calc(100% - 102px)",
      paddingLeft: "10%",
      paddingRight: "10%",
    },
    [theme.breakpoints.down('xs')]: {
      height: "calc(100% - 56px)",
      paddingLeft: "8%",
      paddingRight: "8%",
    },
  },
  image: {
    // width: "75%",
    // height: "75%",
    width: "22vw",
  },
  imageLogin: {
    height: "818px",
    width: "920px",
    paddingLeft: "90px",
    // maxWidth: "650px",
    borderBottomLeftRadius: 4,
    borderTopLeftRadius: 4,
    [theme.breakpoints.down('lg')]: {
      width: "618px",
      height: "550px",
      paddingLeft: "60px",
    },
    [theme.breakpoints.down('md')]: {
      width: 460,
      height: 408,
      paddingLeft: "45px",
      // maxWidth: 500
    },
    [theme.breakpoints.down('sm')]: {
      display: "none"
    },
  },
  grid: {
    // width: "70vw"
  },
  centerContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  },
  logoDiv: {
    padding: "40px 0px 30px",
    [theme.breakpoints.down('lg')]: {
      padding: "24px 0px 16px",
    },
    [theme.breakpoints.down('md')]: {
      padding: "20px 0px 8px",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "30px 0px 20px",
    },
    [theme.breakpoints.down('xs')]: {
      padding: "20px 0px 8px",
    },
  },
  logo: {
    width: 221,
    height: 50,
    [theme.breakpoints.down('lg')]: {
      width: 166,
      height: 40,
    },
    [theme.breakpoints.down('md')]: {
      width: 124,
      height: 28
    },
    [theme.breakpoints.down('sm')]: {
      width: 250,
      height: 50
    },
    [theme.breakpoints.down('xs')]: {
      width: 175,
      height: 28
    },
  }
});

class AuthContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showImage: true,
      backgroundData: ""
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    if (getCookie("backgroundData")) {
      this.setState({ backgroundData: JSON.parse(getCookie("backgroundData")) })
    } else {
      axios.get(`${config.strapiendpoint}/api/getLoginImage`).then(resp => {
        this.setState({ backgroundData: resp?.data?.success })
        const endOfDay = new Date();
        endOfDay.setUTCHours(23, 59, 59, 999);
        const maxAge = Math.floor((endOfDay - new Date()) / 1000);
        setCookie("backgroundData", JSON.stringify(resp?.data?.success), maxAge)
      }).catch(err => {
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    // this.setState({ width: window.innerWidth, height: window.innerHeight });
    if (window.innerWidth < 960 && this.state.showImage)
      this.setState({ showImage: false });
    else if (!this.state.showImage && window.innerWidth >= 960)
      this.setState({ showImage: true });
  };

  onSubmit = (e) => {
    const { classes, formtype, onFormSubmit } = this.props;
    alert("form submit: " + formtype);
    e.preventDefault();
    // return false;
    // onFormSubmit && onFormSubmit()
  }

  render() {
    const { classes, formtype, onFormSubmit } = this.props;

    return (
      <Box style={{ background: this.state.backgroundData?.bgColorCode || "#dadccfbd" }}>
        <_Header />
        <Box
          container="true"
          className={classes.root}
          alignItems={"center"}
          justifyContent={"center"}
          width="100vw"
          display={"flex"}
          flex={1}
        >
          <Grid container className={classes.grid}>
            <Grid item md={6} sm={12} xs={12} className={classes.centerContent}>
              {this.state.backgroundData?.imageUrl && <img
                className={classes.imageLogin}
                src={`${config.strapiendpoint}${this.state.backgroundData?.imageUrl}`}
                alt="default image"
              />}
            </Grid>
            <Grid item md={6} sm={12} xs={12} className={classes.formCenterContent}>
              <Paper className={classes.paper} elevation={3}>
                <div className={[classes.centerContent, classes.logoDiv].join(' ')}>
                  <img
                    src={'../images/tradebulls-logo.svg'}
                    alt="header logo image"
                    className={classes.logo}
                    onClick={() => window.location.href = config.contentendpoint}
                  />
                </div>
                <Box className={[classes.centerContent, classes.formBoxStyle].join(" ")} style={{ flexDirection: "column" }}>
                  <form onSubmit={this.onSubmit} style={{ height: "100%", width: "100%" }}>
                    {this.props.children}
                  </form>
                </Box>
              </Paper>
            </Grid>
            {/* <Grid item xl={2} lg={1} />
            <Grid item xl={8} lg={10}>
              <Grid container>
                <Grid item xl={5} lg={5} className={classes.centerContent}>
                  {this.state.imageUrl && <img
                    className={classes.imageLogin}
                    src={`${config.strapiendpoint}${this.state.imageUrl}`}
                    alt="default image"
                  />}
                </Grid >
                <Grid item xl={2} lg={1} />
                <Grid item xl={5} lg={6} alignContent="center">
                  <Paper className={classes.paper} elevation={3}>
                    <div className={[classes.centerContent, classes.logoDiv].join(' ')}>
                      <img
                        src={'../images/tradebulls-logo.svg'}
                        alt="header logo image"
                        className={classes.logo}
                        onClick={() => window.location.href = config.contentendpoint}
                      />
                    </div>
                    <Box className={[classes.centerContent, classes.formBoxStyle].join(" ")} style={{ flexDirection: "column" }}>
                      <form onSubmit={this.onSubmit} style={{ height: "100%", width: "100%" }}>
                        {this.props.children}
                      </form>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Grid >
            <Grid item xl={2} lg={1} /> */}

            {/*  <Grid item xl={5} lg={5} className={classes.centerContent}>
              {this.state.imageUrl && <img
                className={classes.imageLogin}
                src={`${config.strapiendpoint}${this.state.imageUrl}`}
                alt="default image"
              />}
            </Grid >
            <Grid item xl={2} lg={1} />
            <Grid item xl={5} lg={6} alignContent="center">
              <Paper className={classes.paper} elevation={3}>
                <div className={[classes.centerContent, classes.logoDiv].join(' ')}>
                  <img
                    src={'../images/tradebulls-logo.svg'}
                    alt="header logo image"
                    className={classes.logo}
                    onClick={() => window.location.href = config.contentendpoint}
                  />
                </div>
                <Box className={[classes.centerContent, classes.formBoxStyle].join(" ")} style={{ flexDirection: "column" }}>
                  <form onSubmit={this.onSubmit} style={{ height: "100%", width: "100%" }}>
                    {this.props.children}
                  </form>
                </Box>
              </Paper>
            </Grid> */}
          </Grid >
        </Box >
        <_Footer />
      </Box >
    );
  }
}
export default withStyles(styles)(AuthContainer);
